import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import { getAllTranscation } from "../../../services";
import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  GridRowModes,
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";

function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer></GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "الطلبات",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const AllTranscation = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [loginInput, setLogin] = useState({
    id: "",
    status_type: "Complete",
  });
  const [loginInput1, setLogin1] = useState({
    id: "",
    status_type: "Accept",
  });
  useEffect(() => {
    setIsLoading(true);

    getAllTranscation()
      .then((res) => {
        setUsers(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: "mobile_number",
      headerName: "رقم الموبايل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "amount",
      headerName: "الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "amount_berfore",
      headerName: "الرصيد قبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore_from",
      headerName: "الرصيد القبل من",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after_from",
      headerName: "الرصيد البعد من",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_deducted",
      headerName: "amount_deducted",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "winning_amount",
      headerName: "winning_amount",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "number_transfer",
      headerName: "number_transfer",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          localeText={{
            toolbarColumns: "الأعمدة",
            toolbarFilters: "الفلاتر",
            toolbarDensity: "التباعد",
            toolbarExport: "تصدير",
            filterPanelAddFilter: "إضافة فلتر",
            filterOperatorContains: "تحتوي",
            filterOperatorEquals: "تساوي",
            filterOperatorStartsWith: "تبدأ ب",
            filterOperatorEndsWith: "تنتهي  ب",
            filterOperatorIsAnyOf: "هو أي من",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "غير فارغ",
            toolbarDensityCompact: "دمج",
            toolbarDensityStandard: "معيار",
            toolbarDensityComfortable: "مريح",
            toolbarExportCSV: "تصدير CSV",
            toolbarExportPrint: "طباعة",
            filterPanelInputLabel: "القيمة",
            filterPanelInputPlaceholder: "ادخل القيمة",
            filterPanelColumns: "الاعمدة",
            filterPanelOperators: "العمليات",
            columnsPanelTextFieldLabel: "بحث عن عمود",
            columnsPanelTextFieldPlaceholder: "عنوان العمود",
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default AllTranscation;
